import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";

const useItemStyles = makeStyles({
  root: { width: "750px" },
  selected: { backgroundColor: "white !important" },
});

export default ({ field, handleBlur, options, className }) => {
  const [value, setValue] = useState([]);
  const selectOptions = options || field.options || [];

  useEffect(() => {
    const { value: fieldValue } = field;

    const initialValue = !fieldValue
      ? []
      : typeof fieldValue === "string"
      ? JSON.parse(fieldValue)
      : fieldValue;

    setValue(initialValue);
  }, []);

  return (
    <FormControl variant="outlined" className={className}>
      <InputLabel style={{ padding: "0 7px", backgroundColor: "white" }}>
        {field.label}
      </InputLabel>

      <Select
        renderValue={(v) => v.join(", ")}
        multiple
        value={value}
        id={field.name}
        key={field.name}
        onChange={({ target }) => setValue(target.value)}
        onBlur={handleBlur}
        name={field.name}
      >
        {selectOptions.map((opt) => (
          <MenuItem classes={useItemStyles()} value={opt} key={opt}>
            <Checkbox color="primary" checked={value.indexOf(opt) > -1} />
            <ListItemText primary={<p className="ng-multi-text">{opt}</p>} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
